<template>
  <div class="incoming-tender-list-navigation">
    <div class="incoming-tender-list-navigation_left">
      <Button
        color="neutral"
        type="borderless"
        size="small"
        left-icon="download"
        :loading="downloading"
        @click="downloadAsExcel"
      >
        {{ $t('Export to Excel') }}
      </Button>
    </div>
  </div>
</template>

<script>
  import Button from '@/components/ui/Button';
  import downloadByLink from '@/utils/download-by-link';

  export default {
    name: 'ProjectListNavigation',
    components: {
      Button,
    },
    props: {
      listTitle: String,
    },
    data() {
      return {
        downloading: false,
      };
    },
    methods: {
      async downloadAsExcel() {
        this.downloading = true;
        await downloadByLink({
          link: `/projects/${this.$route.params.id}/xlsx/`,
          fileName: `${this.listTitle}.xlsx`,
        });
        this.downloading = false;
      },
    },
  };
</script>
